<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
            <em name="Exhibition"></em> <span>/</span
            ><span class="px-0">大會活動</span><span>/</span
            ><a href="javascript:history.back()">{{ EventName }}</a
            ><span>/</span>選擇推廣產品
          </div>
          <div>
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="contentBox">
          <div id="SliderTop">
            <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
          </div>
          <h1>選擇推廣產品</h1>
          <p class="my-3">&nbsp;</p>
          <p class="alert">
            您已經報名
            <span class="red">{{ RegisterListNum }}</span> 個產品，還可以選擇
            <span class="red">{{ maxProductQty - RegisterListNum }}</span>
            個產品參加本活動
          </p>
          <p class="my-3">&nbsp;</p>
          <div>
            <ul id="product" v-for="item in ProductList">
              <li>
                <div
                  class="row justify-content-between align-items-center mx-1"
                >
                  <div class="col-md-7">
                    <div
                      class="row ml-md-0 text-center text-md-left align-items-center"
                    >
                      <div class="col-md-3">
                        <div class="mt-md-4 mt-0 mb-md-0 mb-4">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`"
                            class="img-fluid"
                            width="200px"
                            alt="Responsive image"
                          />
                        </div>
                      </div>
                      <!-- <div class="MbDevice col-md-3">
                                            <div class="mt-4">
                                                <img :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`"
                                                    class="img-fluid " width="150px" alt="Responsive image">
                                            </div>
                                        </div> -->

                      <div class="ml-md-3 ml-0 col-md-8">
                        <p class="formTitle mb-2">{{ item.ProName }}</p>
                        <p class="gray">類別：{{ item.CatName }}</p>
                        <p class="gray">
                          官網狀態：
                          <span class="text-danger" v-if="item.Archived == 1"
                            >隱藏</span
                          >
                          <span class="text-success" v-else>顯示</span>
                        </p>
                        <p class="gray">
                          前台：

                          <span v-if="item.Archived == 1">
                            <i class="fas fa-eye mr-1"></i>
                            <span
                              style="color: #1a73e8"
                              class="Preview-style"
                              @click="ProductModal(item.ProNo)"
                              >預覽頁面
                            </span>
                          </span>
                          <span v-else>
                            <i class="fas fa-eye mr-1"></i>
                            <a :href="item.ExhWebsiteProductUrl" target="_blank"
                              >頁面快速連結</a
                            >
                          </span>
                        </p>
                        <p class="gray">更新：{{ item.UpdateTime }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 text-md-right text-center mt-3">
                    <div class="mr-md-5 mr-0">
                      <div
                        class="btn btn-sm btn-primary text-nowrap px-4 py-2"
                        style="font-size: 16px"
                        @click.prevent="toRegisterProduct(item.ProNo)"
                      >
                        選取
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <hr />
            </ul>

            <!-- PC版分頁 -->

            <div
              v-if="totalPage > 1"
              class="pt-3 d-flex justify-content-center"
            >
              <nav>
                <ul class="pagination">
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == 0 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      title="切換前十頁"
                      aria-label="Previous"
                      @click="returntenPage()"
                    >
                      <span aria-hidden="true"
                        ><i class="fas fa-angle-double-left"></i
                      ></span>
                    </a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <a
                      class="page-link"
                      href="#"
                      title="上一頁"
                      aria-label="Previous"
                      @click="lastPage()"
                    >
                      <span aria-hidden="true">
                        <i class="fas fa-angle-left"></i>
                      </span>
                    </a>
                  </li>
                  <li
                    class="page-item"
                    v-for="page in showpage"
                    :key="page"
                    :class="{ active: currentPage == page }"
                  >
                    <a class="page-link" href="#" @click="getPage(page)">{{
                      page
                    }}</a>
                  </li>

                  <li
                    class="page-item"
                    :class="{ disabled: currentPage == totalPage }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      title="下一頁"
                      aria-label="Next"
                      @click="nextPage()"
                    >
                      <span aria-hidden="true"
                        ><i class="fas fa-angle-right"></i
                      ></span>
                    </a>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      title="切換下十頁"
                      aria-label="Next"
                      @click="nexttenPage()"
                    >
                      <span aria-hidden="true"
                        ><i class="fas fa-angle-double-right"></i
                      ></span>
                    </a>
                  </li>
                </ul>
                <p class="text-center mt-2">
                  第 {{ currentPage }} / {{ totalPage }} 頁
                </p>
              </nav>
            </div>
          </div>

          <!-- Modal -->
          <div
            class="modal fade"
            id="openModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="ModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <div>
                    <div class="modal-title h3" id="ModalLabel">
                      <i class="fas fa-eye"></i> 參展產品預覽畫面
                    </div>
                  </div>
                  <!-- <div class="MbDevice">
                                    <div class="modal-title h5" id="ModalLabel"> <i class="fas fa-eye"></i>
                                        參展產品預覽畫面 </div>
                                </div> -->
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <nav>
                    <div
                      class="nav mt-5 mx-3 nav-tabs"
                      id="nav-tab"
                      role="tablist"
                    >
                      <a
                        class="nav-item nav-link active"
                        id="nav-home-tab"
                        data-toggle="tab"
                        href="#nav-home"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                        >中文版</a
                      >
                      <a
                        class="nav-item nav-link"
                        id="nav-profile-tab"
                        data-toggle="tab"
                        href="#nav-profile"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="false"
                        >English</a
                      >
                    </div>
                  </nav>
                  <div class="tab-content mx-2" id="pills-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="nav-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <div class="row mt-5 justify-content-around">
                        <div class="col-4">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${ProductData.ProImg}`"
                            class="img-fluid"
                            width="320px"
                          />
                        </div>
                        <div class="col-7">
                          <div>
                            <div style="font-size: 27px" class="mb-4">
                              {{ ProductData.ProName }}
                            </div>
                          </div>

                          <p>產品型號 : {{ ProductData.ProModel }}</p>
                          <p>產品分類 : {{ SelectCat.mainCatName }}</p>
                          <p>廠商名稱 : {{ companyName }}</p>
                          <p>攤位號碼 : {{ BoothNo }}</p>
                          <hr />
                          <div class="my-3">
                            <p class="category-text-style my-3">產品特色</p>
                            <p
                              class="mb-5"
                              v-html="ProductData.htmlProDesc"
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="tab-pane fade"
                      id="nav-profile"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <div class="row mt-5 justify-content-around">
                        <div class="col-4">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${ProductData.ProImg}`"
                            class="img-fluid"
                            width="320px"
                          />
                        </div>
                        <div class="col-7">
                          <div class="title-text-style mb-4">
                            <div>{{ ProductData.eProName }}</div>
                          </div>
                          <p>Model : {{ ProductData.ProModel }}</p>
                          <p>Category : {{ SelectCat.emainCatName }}</p>
                          <p>Exhibitor : {{ ecompanyName }}</p>
                          <p>Booth No. : {{ BoothNo }}</p>
                          <hr />
                          <div class="my-3">
                            <p class="category-text-style my-3">
                              Characteristic
                            </p>
                            <p
                              class="mb-5"
                              v-html="ProductData.htmleProDesc"
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    關閉
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "選擇推廣產品 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",
      ProductAmount: "",
      ProductData: {},
      companyName: "",
      ecompanyName: "",
      SelectCat: "",
      ProductCategory: [],
      BoothNo: "",

      currentPage: 2,
      totalPage: "",
      totalNo: "",
      ProductRawData: [],
      ProductList: [],
      totaltenPageNum: 0,
      tenPageNum: 0,
      showpage: [],
      lang: "tw",

      eventId: "",

      MarketingRegisterList: [],
      mapEat: [],
      mapEat2: [],
      bbc: [],
      maxProductQty: "",
      RegisterListNum: "",
      EventName: "",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
    };
  },
  methods: {
    getPage(page) {
      const vm = this;

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}&Page=${page}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}&Page=${page}`;
      }
    },

    nextPage() {
      const vm = this;
      let nextP = Number(vm.currentPage) + 1;

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}&Page=${nextP}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}&Page=${nextP}`;
      }
    },

    lastPage() {
      const vm = this;
      let lastP = Number(vm.currentPage) - 1;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}&Page=${lastP}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}&Page=${lastP}`;
      }
    },

    nexttenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum + 1;
      vm.showpage = vm.inquiryRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}&Page=${vm.currentPage}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}&Page=${vm.currentPage}`;
      }
    },

    returntenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum - 1;
      vm.showpage = vm.inquiryRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}&Page=${vm.currentPage}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}&Page=${vm.currentPage}`;
      }
    },

    toRegisterProduct(id) {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionAdd?no=${vm.RegNo}&id=${id}&eventId=${vm.eventId}`;
    },

    ProductModal(id) {
      const vm = this;

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/Product/${vm.RegNo}/${id}`
        )
        .then((response) => {
          vm.ProductData = response.data.Data;

          //核對產品類別，取得已選的類別

          if (vm.ProductData.CatNo) {
            vm.SelectCat = vm.ProductCategory.find((item) => {
              return item.MainCategoryId == vm.ProductData.CatNo;
            });
          } else {
            vm.SelectCat = "";
          }
        });

      $('#openModal a[href="#nav-home"]').tab("show");
      $("#openModal").modal("show");

      // axios.get(url).then(function (response) {
      //   // console.log(response.data)
      //   vm.ProductData = response.data

      //   //核對產品類別，取得已選的類別

      //   if (vm.ProductData.CatNo) {
      //     vm.SelectCat = vm.ProductCategory.find((item) => {
      //       return item.CatNo == vm.ProductData.CatNo
      //     })
      //   } else {
      //     vm.SelectCat = ''
      //   }
      // })

      // if (vm.lang == 'tw') {
      //   $('#openModal a[href="#nav-home"]').tab('show')
      //   $('#openModal').modal('show')
      // } else {
      //   $('#openModal a[href="#nav-profile"]').tab('show')
      //   $('#openModal').modal('show')
      // }
    },
  },

  created() {
    const vm = this;

    //取得語系

    $(() => {
      $("#SliderTop").click(() => {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        return false;
      });

      $(window)
        .scroll(function () {
          if ($(this).scrollTop() > 300) {
            $("#SliderTop").fadeIn(222);
          } else {
            $("#SliderTop").stop().fadeOut(222);
          }
        })
        .scroll();
    });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;

    //取得RegNo
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/ProductCategory/${vm.RegNo}`
      )
      .then((response) => {
        vm.ProductCategory = response.data.Data.ProductMainCategory;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        vm.companyName = response.data.Data.Company;
        vm.ecompanyName = response.data.Data.eCompany;
      });
    if (currentUrl.split("eventId=")[1]) {
      vm.eventId = currentUrl.split("eventId=")[1].split("&")[0];
    }

    let hasPagenum = new URL(currentUrl);
    vm.currentPage = hasPagenum.searchParams.get("Page");

    if (!vm.currentPage) {
      vm.currentPage = 1;
    }

    //取得產品列表
    let url = `https://www.chanchao.com.tw/apiExhibitors/Product/${vm.RegNo}?mode=more&Page=${vm.currentPage}`;

    axios.get(url).then(function (response) {
      if (response.data.Code == 200) {
        vm.totalNo = response.data.datatotal;

        if (response.data.pagetotal > 0) {
          vm.ProductList = response.data.Data;

          vm.totalPage = response.data.pagetotal;

          for (let i = 0; i < vm.totalPage; i++) {
            if (i % 10 === 0) {
              vm.ProductRawData.push([]);
            }

            const page = parseInt(i / 10); //取parseInt整數
            vm.ProductRawData[page].push(i + 1);
          }

          //totaltenPageNum 取得共有幾筆十頁
          vm.totaltenPageNum = vm.ProductRawData.length;
          //從取得的筆數後，tenNum 計算出現第幾個十頁數

          let anaNowPage = vm.currentPage - 1; //判定第幾頁(十頁)，頁數減一避免進位

          vm.tenPageNum = parseInt(anaNowPage / 10);
          vm.showpage = vm.ProductRawData[vm.tenPageNum];
        }
      } else if (response.data.Code == 404) {
        vm.totalNo = 0;
        vm.totalPage = 0;
      }
    });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MarketingEventRegister?regNo=${vm.RegNo}&eventId=${vm.eventId}`
      )
      .then((response) => {
        vm.MarketingRegisterList = response.data.Data;
        // vm.RegisterListNum = response.data.datatotal

        if (response.data.datatotal) {
          vm.RegisterListNum = response.data.datatotal;
        } else {
          vm.RegisterListNum = 0;
        }
      });

    //取得線上展總資料
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MarketingEvent?eventId=${vm.eventId}`
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.maxProductQty = response.data.Data.maxProductQty;

        // 開啟時間判定
        let OpenRegiterDate = response.data.Data.backEndStartDate;
        let CloseRegiterDate = response.data.Data.backEndEndDate;

        vm.EventName = response.data.Data.eventName;
        let Nowdate = Date.parse(new Date()).valueOf();

        if (Nowdate < OpenRegiterDate) {
          alert("活動尚未開放");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (Nowdate > CloseRegiterDate) {
          alert("活動尚未開放");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        }
      });
  },
};
</script>

<style lang="scss"></style>
